var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container section"},[_c('div',{staticClass:"text-module",class:{ 'text-module__text--center': _vm.content.textCenter },style:(_vm.cssVars),domProps:{"innerHTML":_vm._s(_vm.content.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }